import { ArrowForwardIos } from "@mui/icons-material";

function Breadcrumbs({ pageType }) {

const breadCrumbStyle = {
  color: "#cccccc",
  fontSize: "1rem",
  textDecoration: "underline",
};

  return (
    <div style={{marginTop:"1rem" }}>
        <span style={breadCrumbStyle}>Masters </span>{" "}
        <ArrowForwardIos color="info" style={{ marginRight: "1rem" }} />
        <span style={breadCrumbStyle}>RSP Change Approve</span>
    </div>
  );
}
export default Breadcrumbs;
